module.exports = __webpack_public_path__ + "static/img/y-6.eee27850.png";